module.exports = __webpack_public_path__ + "img/maobi13.6bb35c80.png";